export * from './DadosDeProdutoServiceAdapter'
export * from './DadosDeVendaServiceAdapter'
